import { render, staticRenderFns } from "./Icon2.vue?vue&type=template&id=0c14ae60"
import script from "./Icon2.vue?vue&type=script&lang=js"
export * from "./Icon2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports